import React from "react"
import { Link, navigate } from "gatsby"

const CategoriesNav = ({ categories }) => {
  const handleOnChange = e => {
    if (!e.target.value) navigate("/blog/")
    navigate(`/blog/categories/${e.target.value}`)
  }

  return (
    <div className="mb-12 relative z-10">
      <h3 className="text-3xl serif mb-6">Categories</h3>
      <div className="sm:hidden">
        <select
          aria-label="Selected tab"
          className="form-select block w-full"
          onChange={handleOnChange}
        >
          <option value="null">All</option>
          {categories.map(category => {
            return (
              <option key={category.slug} value={category.slug}>
                {category.name}
              </option>
            )
          })}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="flex space-x-2">
          <Link
            to="/blog/"
            activeClassName="bg-jnl-red-medium text-white"
            className="px-3 py-2 font-thin text-sm leading-5 rounded-full bg-gray-100 hover:text-white hover:bg-jnl-teal-dark focus:outline-none focus:text-gray-700 focus:bg-gray-200"
          >
            All Categories
          </Link>
          {categories.map(category => (
            <Link
              key={category.slug}
              to={`/blog/categories/${category.slug}`}
              activeClassName="bg-jnl-red-medium text-white"
              className="px-3 py-2 font-thin text-sm leading-5 rounded-full bg-gray-100 hover:text-white hover:bg-jnl-teal-dark focus:outline-none focus:text-gray-700 focus:bg-gray-200"
            >
              {category.name}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  )
}

export default CategoriesNav
